var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbgDairyV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E2F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_54090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6074 26.3989C21.0719 26.3989 21.4464 25.9982 21.4464 25.5013V19.4265C21.4464 16.8299 20.8471 14.2814 19.7086 11.9893C19.8659 11.9252 20.0082 11.813 20.1056 11.6607C20.2029 11.5084 20.2554 11.3321 20.2554 11.1478V10.4906C20.2554 10.2502 20.1655 10.0258 20.0082 9.85749C19.8509 9.68919 19.6412 9.59302 19.4164 9.59302H16.6C16.3752 9.59302 16.1655 9.68919 16.0082 9.85749C15.8509 10.0258 15.761 10.2502 15.761 10.4906V11.1478C15.761 11.3321 15.8134 11.5084 15.9108 11.6607C16.0082 11.813 16.143 11.9252 16.3078 11.9893C15.1618 14.2814 14.5625 16.8379 14.5625 19.4345V25.5013C14.5625 25.886 14.7647 26.3989 15.4089 26.3989H20.6074Z",
    stroke: "#0071E3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2734 15.235C15.5506 15.2751 15.7004 15.3953 15.8952 15.5315C16.1573 15.7239 16.457 15.9483 17.0262 15.9483C17.5955 15.9483 17.8952 15.7239 18.1573 15.5315C18.3895 15.3552 18.5768 15.219 18.9813 15.219C19.3858 15.219 19.5656 15.3552 19.7978 15.5315C20.0225 15.6998 20.2847 15.8922 20.7191 15.9403",
    stroke: "#0071E3",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9969 26.0462L14.6523 17.7114L15.4538 15.5876H20.7272L21.4389 19.4345L21.2666 26.0462H18.2778H14.9969Z",
    fill: "#0071E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_54090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 18,
    fill: "white",
    transform: "translate(14 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbgDairyV2);
export default __webpack_public_path__ + "static/media/wbg-dairy-v2.7a030939eb86036cb61a6989cfa7297e.svg";
export { ForwardRef as ReactComponent };